import { render, staticRenderFns } from "./questionbankImport.vue?vue&type=template&id=7e4b50cf&"
import script from "./questionbankImport.vue?vue&type=script&lang=js&"
export * from "./questionbankImport.vue?vue&type=script&lang=js&"
import style0 from "./questionbankImport.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports